import { render, staticRenderFns } from "./ActivityWsKaraoke.vue?vue&type=template&id=58fe30d6&scoped=true"
import script from "./ActivityWsKaraoke.vue?vue&type=script&lang=ts"
export * from "./ActivityWsKaraoke.vue?vue&type=script&lang=ts"
import style0 from "./ActivityWsKaraoke.vue?vue&type=style&index=0&id=58fe30d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fe30d6",
  null
  
)

export default component.exports